import React from 'react';
import { Link } from 'react-router-dom';
import { Navigations } from './Navigations';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faLinkedin,
    faGithub,
    faTwitter,
    faDiscord,
    faItchIo,
    faMedium
} from "@fortawesome/free-brands-svg-icons";

export const Header = () => {
    const socialMediaLinks = [
        { href: "https://www.linkedin.com/in/abhinavrajat/", label: "LinkedIn", icon: faLinkedin },
        { href: "https://github.com/abhinav1229", label: "GitHub", icon: faGithub },
        { href: "https://medium.com/@rk7772534", label: "Medium", icon: faMedium },
        { href: "https://abhinav1229.itch.io/", label: "Itchio", icon: faItchIo },
        { href: "https://discord.com/channels/@me/1218121969535549492", label: "Discord", icon: faDiscord },
    ];

    return (
        <div className="header font-secondary">
            <div className="container fx-col pd">
                {/* Upper Section */}
                <div className="section fx fx-far">
                    <div className="panel-left fx fx-center fx-gap-s ft-s-medium-prime txt-upper">
                        <div className="ft-w-bold c-prime">Abhinav</div>
                        <div className="seperator-line">|</div>
                        <div className="c-light ft-s-medium">Game Developer</div>
                    </div>
                    <div className="social-media-links fx fx-gap-social fx-center">
                        {socialMediaLinks.map(link => (
                            <Link key={link.label} to={link.href} target="_blank" rel="noopener noreferrer" className='txt-no-decorate nav-links-default-color'>
                                <FontAwesomeIcon icon={link.icon} />
                            </Link>
                        ))}
                    </div>
                </div>
                {/* A Line Seperator */}
                <div className="section">
                    {/* <hr /> */}
                    <div className="h-rule mg-y-46"></div>
                </div>

                {/* Page Navigations */}
                <div className="section">
                    <Navigations />
                </div>
            </div>
        </div>
    );
};
